import { NgClass } from '@angular/common';
import { Component, computed } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BaseDataGridCellRenderer } from 'shared/abstract/base-data-grid-cell-renderer';

export interface ButtonData {
    label: string | Function;
    icon: string | Function;
    clickHandler: Function;
    displayButton?: Function;
    disabled?: boolean | Function;
    showLoader?: boolean | Function;
}

export interface ResolvedButtonData {
    label: string;
    icon: string;
    clickHandler: Function;
    displayButton?: Function;
    disabled: boolean;
    showLoader: boolean;
}

@Component({
    selector: 'app-default-data-grid-action-cell-renderer',
    templateUrl: './default-data-grid-action-cell-renderer.component.html',
    styleUrls: ['./default-data-grid-action-cell-renderer.component.scss'],
    imports: [TranslateModule, NgClass],
})
export class DefaultDataGridActionCellRendererComponent extends BaseDataGridCellRenderer {
    public buttons = computed<ResolvedButtonData[]>(() => {
        if (!this.column || !this.data) {
            return [];
        }

        let rawButtons: ButtonData[];
        if (Array.isArray(this.column.customCellRendererData)) {
            rawButtons = this.column.customCellRendererData.filter((renderer: any) => this.isButtonData(renderer));
        } else {
            rawButtons = this.column.customCellRendererData;
        }

        return rawButtons.map((button) => {
            const disabled = typeof button.disabled === 'function' ? button.disabled(this.data) : (button.disabled ?? false);
            const showLoader = typeof button.showLoader === 'function' ? button.showLoader(this.data) : (button.showLoader ?? false);

            return {
                label: typeof button.label === 'function' ? button.label(this.data) : button.label,
                icon: typeof button.icon === 'function' ? button.icon(this.data) : button.icon,
                clickHandler: button.clickHandler,
                displayButton: button.displayButton,
                disabled: disabled,
                showLoader: showLoader,
            };
        });
    });

    constructor() {
        super();
    }

    onDataChange(): any {}

    public buttonClickHandler(index: number) {
        if (this.buttons()[index].disabled) {
            return;
        }

        this.buttons()[index].clickHandler(this.data as { [key: string]: any });
    }

    public buttonDisplayHandler() {
        return this.buttons().every((button: any) => (button.displayButton?.call(this, this.data) ?? true) == true);
    }

    private isButtonData(object: any): object is ButtonData {
        return 'label' in object && 'icon' in object && 'clickHandler' in object;
    }
}
